// generateCanonicalAndAlternates.js
'use strict';

import { alternateDomainMap } from '../resource/seoConstants.js';

/**
 * Generate canonical URL and alternate language links for SEO
 * @param {Object} options
 * @param {string} options.canonicalPath - The canonical path (e.g., '/user/123')
 * @param {string|Array} options.availableLanguages - Available languages (string or array)
 * @returns {Object} Object with canonical and alternates
 */
const generateCanonicalAndAlternates = ({
  canonicalPath,
  availableLanguages,
}) => {
  if (!canonicalPath) {
    return {
      canonical: null,
      alternates: null,
    };
  }

  // Prepare canonical URL
  const currentHostname = alternateDomainMap.default;
  const canonical = `https://${currentHostname}${canonicalPath}`;

  // Prepare alternate language links
  const alternates = [];
  if (availableLanguages) {
    const languages =
      typeof availableLanguages === 'string'
        ? availableLanguages.split(' ').filter(Boolean)
        : Array.isArray(availableLanguages)
          ? availableLanguages
          : [];

    languages.forEach(lang => {
      const langHostname =
        alternateDomainMap[lang.toLowerCase()] || alternateDomainMap.default;
      alternates.push({
        hreflang: lang,
        href: `https://${langHostname}${canonicalPath}`,
      });

      // Add zh-TW as additional alternate for zh-Hant
      if (lang.toLowerCase() === 'zh-hant') {
        alternates.push({
          hreflang: 'zh-TW',
          href: `https://${langHostname}${canonicalPath}`,
        });
      }
    });

    // Add x-default
    const xDefaultHostname = alternateDomainMap.default;
    alternates.push({
      hreflang: 'x-default',
      href: `https://${xDefaultHostname}${canonicalPath}`,
    });
  }

  return {
    canonical,
    // NOTE: Follow Nextjs behavior, remove all alternates herflang
    // References: https://github.com/swaglive/swag-webapp/pull/10406
    alternates: null,
  };
};

export default generateCanonicalAndAlternates;
